export const LANDING_LANDING_SET_DATA = 'LANDING_LANDING_SET_DATA';
export const LANDING_BOOKSET_IDS = {
  5843: 'business',
  1099: 'novelty',
  683: 'free',
  7302: 'audio',
};
export const LANDING_NICHE_SLUGS = ['detektivy', 'fantastika'];
export const LANDING_GENRE_SLUGS = ['marketing-pr-reklama-2', 'prodazhi', 'tajm-menedzhment',
  'lichnaya-effektivnost', 'menedzhment', 'peregovory'];

export const catalogSlide = {
  title: 'Все книги доступны одновременно',
  description: 'Пользуйтесь подпиской – безлимитным абонементом на весь каталог',
  imageClassName: 'catalogImage',
};
export const recomendationsSlide = {
  title: 'Персональные рекомендации',
  description: 'Подбираем книги по вашему вкусу на основе того, что вы прочитали',
  imageClassName: 'recomendationsImage',
};
export const statisticsSlide = {
  title: 'Статистика \n чтения',
  description: 'Показываем время, скорость и прогресс вашего чтения в приложении',
  imageClassName: 'statisticsImage',
};
